export const CRON_JOBS_TEST_IDS = {
  PAGE: 'cron-jobs-page',
  JOB_NAME_SELECT: 'cron-jobs-job-name-select',
  TABLE: 'cron-jobs-table',
  TABLE_ROW: (id: string) => `cron-jobs-table-row-${id}`,
  COL_REQUEST_ID: (id: string) => `cron-jobs-col-request-id-${id}`,
  COL_JOB_NAME: (id: string) => `cron-jobs-col-job-name-${id}`,
  COL_STATUS: (id: string) => `cron-jobs-col-status-${id}`,
  COL_START_TIME: (id: string) => `cron-jobs-col-start-time-${id}`,
  COL_END_TIME: (id: string) => `cron-jobs-col-end-time-${id}`,
  COL_CREATED_ON: (id: string) => `cron-jobs-col-created-on-${id}`,
  COL_UPDATED_ON: (id: string) => `cron-jobs-col-updated-on-${id}`,

  // ── Expanded row panel ───────────────────────────────────────────────
  EXPANDED_PANEL: 'cron-jobs-expanded-panel',
  EXPANDED_REPORT: 'cron-jobs-expanded-report',
  EXPANDED_METADATA: 'cron-jobs-expanded-metadata',
} as const;
